import React, { ReactNode } from 'react'
import BaseLayout from './base'

const DocsLayout = ({ children }: { children: ReactNode }) => (
    <BaseLayout withSidebar hasLogin>
        {children}
    </BaseLayout>
)

export default DocsLayout
